import React from 'react';
import { theme } from 'antd';
import TitleBar from 'components/TitleBar';
import Allocation from 'components/Allocation/Allocation';
import { TitleList } from 'store/ducks/globalTypes';
import { useTranslation } from 'react-i18next';
import * as Styled from '../Layout.styled';

const { useToken } = theme;

const AllocationLayout: React.FC = () => {
  const { token } = useToken();
  const { t } = useTranslation();

  return (
    <Styled.StyledLayout token={token}>
      <TitleBar title={t(TitleList.ALLOCATION)} />
      <Styled.HorizontalLayoutMain>
        <Styled.Container>
          <Allocation />
        </Styled.Container>
      </Styled.HorizontalLayoutMain>
    </Styled.StyledLayout>
  );
};

export default AllocationLayout;
